import request from "@/api/request";
import { Meta } from "@/interfaces/Pages/Meta";
import { CustomPage } from "@/interfaces/Pages/CustomPage.ts";

class PagesService {
  static async sendMessage(subject: string, message: string, email: string, captcha: string | null): Promise<void> {
    return await request.post("/pages/contact_us", {
      subject,
      message,
      email,
      captcha,
    });
  }

  static async contentReport(
    category: string,
    name: string,
    email: string,
    url: string,
    is_depicted: string,
    is_agreed: string,
    reason: string,
    captcha: string | null,
  ): Promise<void> {
    return await request.post("/pages/content_report", {
      category,
      name,
      email,
      url,
      is_depicted,
      is_agreed,
      reason,
      captcha,
    });
  }

  static async get(url: string, password: string | null = null): Promise<CustomPage> {
    return await request.get(`/pages${url}`, { password });
  }

  static async seo(path: string): Promise<Meta> {
    return await request.get("/pages/meta", { url: path });
  }
}

export default PagesService;
